import styled from 'styled-components'

const Container = styled.div<{ noMargin?: boolean }>`
  margin: ${(props): string => (props.noMargin ? '0px' : '20px 0px')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`

const Description = styled.div`
  margin-bottom: 20px;
  font-size: 19px;
  text-align: center;
`

const Action = styled.div`
  font-size: 15px;
  margin-bottom: 20px;
`

export default {
  Container,
  Description,
  Action
}
